import gql from 'graphql-tag';

import {
    licensePaymentMethodFragment,
    officeEmployee,
    organisationInfo,
    organisationLicensePayment,
    organisationLicensePaymentAddress,
    organisationOffice,
    organisationSmsPackagePayment,
    organisationTariff,
} from '../fragments';

export const getOrganisationLabelsById = gql`
    query GetOrganisationLabelsById($organisationId: Int!) {
        organisationLabelsById(organisationId: $organisationId) {
            id
            labelId
            name
            color
        }
    }
`;

export const getOrganisations = gql`
    query GetOrganisations {
        organisations {
            ...OrganisationInfo
            offices {
                ...OrganisationOfficeFragment
            }
            organisationTariff {
                ...OrganisationTariffFragment
            }
            licensePaymentAddress {
                ...OrganisationLicensePaymentAddressFragment
            }
            founder {
                ...OfficeEmployeeFragment
            }
        }
    }
    ${organisationInfo}
    ${organisationOffice}
    ${organisationTariff}
    ${organisationLicensePaymentAddress}
    ${officeEmployee}
`;

export const getOrganisationById = gql`
    query GetOrganisationById($organisationId: Long!) {
        organisationById(organisationId: $organisationId) {
            ...OrganisationInfo
            offices {
                ...OrganisationOfficeFragment
            }
            organisationTariff {
                ...OrganisationTariffFragment
            }
            licensePaymentAddress {
                ...OrganisationLicensePaymentAddressFragment
            }
            lastOrganisationLicensePayment {
                ...OrganisationLicensePaymentFragment
            }
        }
    }
    ${organisationInfo}
    ${organisationOffice}
    ${organisationTariff}
    ${organisationLicensePaymentAddress}
    ${organisationLicensePayment}
`;

export const getOfficeLicensePaymentMethodsByOfficeId = gql`
    query GetOfficeLicensePaymentMethodsByOfficeId($organisationId: Int!, $officeId: Int!) {
        licensePaymentMethodsByOfficeId(organisationId: $organisationId, officeId: $officeId) {
            ...OrganisationLicensePaymentMethodOutputFragment
        }
    }
    ${licensePaymentMethodFragment}
`;

export const getOrganisationLicensePaymentsById = gql`
    query GetOrganisationLicensePaymentsById($officeId: Int!, $organisationId: Int!) {
        organisationLicensePaymentsById(officeId: $officeId, organisationId: $organisationId) {
            ...OrganisationLicensePaymentFragment
        }
    }
    ${organisationLicensePayment}
`;

export const getOrganisationSmsPackagesOrdersById = gql`
    query GetOrganisationSmsPackagesOrdersById($officeId: Int!, $organisationId: Int!) {
        organisationSmsPackagesOrdersById(officeId: $officeId, organisationId: $organisationId) {
            ...OrganisationSmsPackagePaymentFragment
        }
    }
    ${organisationSmsPackagePayment}
`;
